import { Component, OnInit, AfterViewInit, Inject, Output, EventEmitter } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { DbService } from '../core/services/db.service';
import { AuthService } from '../core/services/auth.service';
import { AlertService } from '../core/services/alert.service';
import { map } from 'rxjs';
import { Notification } from '../core/models/notification.models';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  configData;
  openSwitch = false;

  menu = [
    {
      label: '대시보드',
      icon: 'bx-home',
      link: '/dashboard',
    },
    {
      label: '회원 관리',
      icon: 'bx bx-user',
      subItems: [
        {
          label: '일반 회원 관리',
          link: '/user-list',
        },
        {
          label: '1:1문의 관리',
          link: '/inquiry',
        },
      ],
    },
    {
      label: '상품 관리',
      icon: 'bx bx-music',
      subItems: [
        {
          label: '아티스트관리',
          link: '/artist',
        },
        {
          label: '분위기',
          link: '/atmosphere',
        },
        {
          label: '상품 관리',
          link: '/product',
        },
      ],
    },

    {
      label: '펀딩신청 관리',
      icon: 'bx bx-money',
      link: '/funding-proposal',
    },

    {
      label: '예약결제 관리',
      icon: 'bx bx-calendar-event',
      link: '/payment',
    },

    {
      label: '배너/검색어 관리',
      icon: 'bx bx-search-alt',
      subItems: [
        {
          label: '배너 관리',
          link: '/banner-setting',
        },
        {
          label: '인기검색어 관리',
          link: '/trending-search',
        },
      ],
    },

    {
      label: '공연입장 관리',
      icon: 'mdi mdi-ticket-confirmation-outline',
      link: '/ticket',
    },

    {
      label: '서비스/정보관리',
      icon: 'bx-note',
      subItems: [
        {
          label: '공지사항',
          link: '/notice',
        },
        {
          label: 'FAQ 관리',
          link: '/faq',
        },
        {
          label: '약관 관리',
          link: '/terms',
        },
        {
          label: '회사정보 관리',
          link: '/footer-setting',
        },
      ],
    },
  ];

  routerUrl: string;

  constructor(
    // private eventService: EventService,
    private router: Router,
    @Inject(DOCUMENT) private document: any,

    private db: DbService,
    private auth: AuthService,
    private alertService: AlertService
  ) {
    router.events.forEach(event => {
      if (event instanceof NavigationEnd) {
        // this._activateMenuDropdown();
        this.routerUrl = event.url;
      }
    });
  }

  ngOnInit() {
    //사이드바 정의
    document.body.setAttribute('data-sidebar', 'dark');
    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.getNotifications();
  }

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  isCondensed = false;

  // 알림 데이터 불러오기
  notifications$: Notification | any;
  unReadLength: number = 0;
  async getNotifications() {
    this.notifications$ = this.db
      .collection$(`notifications`, ref =>
        ref.where('uuid', '==', 'Vw5ChPza8dalQWJCcvG8HNdNQ1a2').where('deleteSwitch', '==', false).orderBy('dateCreated', 'desc')
      )
      .pipe(
        map((notifications: Notification[] | any) => {
          this.unReadLength = notifications.filter(notification => !notification.readSwitch).length;

          return notifications;
        })
      );
  }

  // 알림 [상세]
  async alarm(item: Notification) {
    await this.db.updateAt(`notifications/${item.id}`, {
      readSwitch: true,
    });

    this.router.navigateByUrl(`${item.url}`);
  }

  //알림 전체 삭제하기
  async removeAll() {
    const ok = await this.alertService.successConfirm('전체 삭제하시겠습니까?');

    if (ok) {
      this.notifications$.forEach((notifications: Notification[]) => {
        notifications.forEach(notification => {
          this.db.updateAt(`notifications/${notification.id}`, {
            readSwitch: true,
            deleteSwitch: true,
          });
        });
      });
    }
  }

  // 알림내역 시간 표시
  displayedAt(dateCreated: string) {
    const diff = dayjs().diff(dayjs(dateCreated), 'minutes');
    const diffHour = dayjs().diff(dayjs(dateCreated), 'hours');

    const timeIntervals = [
      { maxDiff: 1, text: '방금전' },
      { maxDiff: 60, text: `${diff}분 전` },
      { maxDiff: 60 * 23, text: `${diffHour}시간 전` },
      { maxDiff: Infinity, text: dayjs(dateCreated).format('YYYY.MM.DD') },
    ];

    const selectedInterval = timeIntervals.find(interval => diff < interval.maxDiff);

    return selectedInterval?.text;
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
    this.onSettingsButtonClicked();
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;
    document.body.classList.toggle('sidebar-enable');
    document.body.classList.toggle('vertical-collpsed');

    if (window.screen.width <= 768) {
      document.body.classList.remove('vertical-collpsed');
    }
  }

  ngAfterViewInit() {
    // this._activateMenuDropdown();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  scrollable() {
    document.body.setAttribute('data-layout-scrollable', 'true');
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    // this.mobileMenuButtonClicked.emit();
    this.onToggleMobileMenu();
  }

  /**
   * Logout the user
   */
  logout() {
    this.auth.logoutUser().then(() => {
      this.router.navigate(['/account/login']);
    });
  }

  public hide() {
    document.body.classList.remove('right-bar-enabled');
  }

  open(list, menu, mi) {
    const activeTag = document.querySelector<HTMLElement>('.active');
    if (activeTag) {
      activeTag.classList.remove('active');
    }
    if (list.openSwitch) {
      list.openSwitch = false;
    } else {
      list.openSwitch = true;
      menu.forEach(ele => {
        if (ele != list && ele.openSwitch == true) {
          ele.openSwitch = false;
        }
      });

      if (list.subItems && list.subItems.length > 0) {
        for (let index = 0; index < list.subItems.length; index++) {
          const element = list.subItems[index];

          if (element.link == this.routerUrl) {
            const aTag = document.querySelector<HTMLElement>(`.atag${mi}${index}`);
            aTag.classList.add('active');
          }
        }
      }
    }
  }

  close(aTag: HTMLElement) {
    aTag.classList.add('active');
    this.menu.forEach((ele: any) => {
      ele.openSwitch = false;
    });
  }

  //클릭시 active class
  // _activateMenuDropdown() {
  //   this._removeAllClass('mm-active');
  //   this._removeAllClass('mm-show');
  //   const links = document.getElementsByClassName('side-nav-link-ref');
  //   let menuItemEl = null;
  //   // tslint:disable-next-line: prefer-for-of
  //   const paths = [];
  //   for (let i = 0; i < links.length; i++) {
  //     paths.push(links[i]['pathname']);
  //   }
  //   var itemIndex = paths.indexOf(window.location.pathname);
  //   if (itemIndex === -1) {
  //     const strIndex = window.location.pathname.lastIndexOf('/');
  //     const item = window.location.pathname.substr(0, strIndex).toString();
  //     menuItemEl = links[paths.indexOf(item)];
  //   } else {
  //     menuItemEl = links[itemIndex];
  //   }
  //   if (menuItemEl) {
  //     menuItemEl.classList.add('active');
  //     const parentEl = menuItemEl.parentElement;
  //     if (parentEl) {
  //       parentEl.classList.add('mm-active');
  //       const parent2El = parentEl.parentElement.closest('ul');
  //       if (parent2El && parent2El.id !== 'side-menu') {
  //         parent2El.classList.add('mm-show');
  //         const parent3El = parent2El.parentElement;
  //         if (parent3El && parent3El.id !== 'side-menu') {
  //           parent3El.classList.add('mm-active');
  //           const childAnchor = parent3El.querySelector('.has-arrow');
  //           const childDropdown = parent3El.querySelector('.has-dropdown');
  //           if (childAnchor) {
  //             childAnchor.classList.add('mm-active');
  //           }
  //           if (childDropdown) {
  //             childDropdown.classList.add('mm-active');
  //           }
  //           const parent4El = parent3El.parentElement;
  //           if (parent4El && parent4El.id !== 'side-menu') {
  //             parent4El.classList.add('mm-show');
  //             const parent5El = parent4El.parentElement;
  //             if (parent5El && parent5El.id !== 'side-menu') {
  //               parent5El.classList.add('mm-active');
  //               const childanchor = parent5El.querySelector('.is-parent');
  //               if (childanchor && parent5El.id !== 'side-menu') {
  //                 childanchor.classList.add('mm-active');
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // }

  // // 메뉴 클릭시 다른주소 remove class
  // _removeAllClass(className) {
  //   const els = document.getElementsByClassName(className);
  //   while (els[0]) {
  //     els[0].classList.remove(className);
  //   }
  // }
}
